/* global localStorage */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push as routerPush } from 'react-router-redux';
import injectSheet from 'react-jss';
import Avatar from 'material-ui/Avatar';
import ForumIcon from 'material-ui/svg-icons/communication/forum';
import MailIcon from 'material-ui/svg-icons/communication/live-help';
import ContractIcon from 'material-ui/svg-icons/action/description';

import IconWithCounter from './icon-with-counter';
import { getStatusMessages } from '../../workspace/store/actions';
import PopoverList from './popover-list';
import { openModal as openMassDialog } from '../../massmessaging/store/actions';


class MessagingNotification extends React.Component {

  componentDidMount() {
    clearInterval(this.timer);
    this.timedUpdate();
    if (!localStorage.stopAutoReload) {
      this.timer = setInterval(this.timedUpdate, 30e3);
    }
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  setIcon = (item) => {
    const { classes } = this.props;
    const primaryIcon = (() => {
      if (item.profileImageUrl) {
        return (
          <Avatar
            className={classes.avatar}
            src={item.profileImageUrl}
          />
        );
      }
      // item.connectionId === 'inbox', 'contracting' , 'general'
      return (
        <Avatar className={classes.avatar}>
          {(item.otherSideName || '?')[0].toUpperCase()}
        </Avatar>
      );
    })();

    const secondaryIcon = ({
      contracting: () => <ContractIcon className={classes.secondaryIcon} />,
      general: () => <ForumIcon className={classes.secondaryIcon} />,
    }[item.channelId] || (() => <MailIcon className={classes.secondaryIcon} />))();
    return {
      ...item,
      leftIcon: (
        <div>
          {primaryIcon}
          <Avatar className={classes.secondaryAvatar} icon={secondaryIcon} />
        </div>
      ),
    };
  }

  timedUpdate = () => {
    const { loading, getStatusMessages: getMessages } = this.props;
    if (!loading) getMessages();
  }

  render() {
    const {
      routerPush: push,
      latestMessages,
      openMassDialog: newMessage,
      companyType,
    } = this.props;
    return (
      <PopoverList
        list={latestMessages.slice(0, 100).map(this.setIcon)}
        title="Messages"
        clickItem={(id) => {
          const item = latestMessages.find(e => e.id === id);
          if (!item) return;
          if (item.partnerId === 'inbox') { // unassigned inbox
            push(`/workspace/inbox/${item.id}`);
          } else if (item.channelId === 'contracting' && item.contractId) {
            if (item.isWs && companyType === 'Contractor') {
              push(`/contracting/workspace/${item.contractId}/activities?latest=true`);
            } else push(`/contracting/contract/${item.contractId}/activities?latest=true`);
          } else if (item.partnerId) {
            window.location = (`${process.env.NEW_SYSTEM_URL}/partner-management/partner-details/${item.partnerId}?jwt=${localStorage.getItem('jwt')}`);
          }
        }}
        topRightText="New Message"
        topRightAction={newMessage}
        bottomLeftText="Unassigned"
        bottomLeftAction={() => {
          push('/workspace/inbox');
        }}
      >
        <IconWithCounter
          style={{ display: 'flex', minWidth: '50px' }}
          icon={<ForumIcon />}
          count={latestMessages.filter(e => e.unread).length}
          // onTap={() => {
          //   push('/workspace/');
          // }}
        />
      </PopoverList>
    );
  }
}

MessagingNotification.propTypes = {
  classes: PropTypes.object,
  latestMessages: PropTypes.array,
  loading: PropTypes.bool,
  openMassDialog: PropTypes.func,
  routerPush: PropTypes.func,
  getStatusMessages: PropTypes.func,
  companyType: PropTypes.string,
};

const mapStateToProps = ({
  workspace: {
    latestMessages,
    statusMessagesLoading: loading,
  },
  user,
}) => ({
  latestMessages,
  loading,
  companyType: user.getIn(['user', 'type']),
});
export default connect(mapStateToProps, {
  getStatusMessages,
  routerPush,
  openMassDialog,
})(injectSheet({
  avatar: {
    border: 'solid 1px #bbb',
    color: 'white !important',
    height: '40px !important',
    lineHeight: '37px',
    marginTop: '-9px !important',
    textAlign: 'center',
    width: '40px !important',
  },
  secondaryAvatar: {
    backgroundColor: '#767779 !important',
    height: '20px !important',
    left: '25px',
    position: 'absolute',
    top: '20px',
    width: '20px !important',
  },
  secondaryIcon: {
    margin: '3px !important',
  },
  iconStyle: {
    color: 'rgba(0, 0, 0, 0.44) !important',
  },
})(MessagingNotification));



// WEBPACK FOOTER //
// ./src/app/components/app-bar/notification/messaging.jsx